import Vue from "vue"

export const signature = {
    namespaced: true,
    state: {
        signature: null,
        signatureInfo: null,
        addSignerName: false
    },
    actions: {
        setSignature({ commit }, { signature }) {
            commit('setSignature', { signature });
        },
        setSignatureInfo({ commit }, signatureInfo) {
            commit('setSignatureInfo', signatureInfo)
        },
        setAddSignerName({ commit }, { addSignerName }) {
            commit('setAddSignerName', { addSignerName });
        }
    },
    mutations: {
        setSignature(state, { signature }) {
            Vue.set(state, 'signature', signature);
        },
        setSignatureInfo(state, signatureInfo) {
            Vue.set(state, 'signatureInfo', signatureInfo);
        },
        setAddSignerName(state, { addSignerName }) {
            Vue.set(state, 'addSignerName', addSignerName);
        }
    },
    getters: {
        getSignature: state => state.signature,
        getSignatureInfo: state => state.signatureInfo,
        getAddSignerName: state => state.addSignerName
    }
}